import { Route } from '@angular/router';
import { AuthGuard } from '@freesixtyfive/auth';
import { MenuItem } from 'primeng/api';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { ImprintPageComponent } from './pages/imprint-page/imprint-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { ResetPasswordComponent } from './pages/reset-password/reset-password.component';

export const appRoutes: Route[] = [
  {
    path: '',
    redirectTo: 'locations/list',
    pathMatch: 'full',
  },
  {
    path: 'login',
    title: 'mblty IQ - Login',
    component: LoginPageComponent,
    data: {
      breadcrumbs: [{ label: 'Login' }] as MenuItem[],
    },
  },
  {
    path: 'forgot-password',
    title: 'mblty IQ - Forgot Password',
    component: ForgotPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Forgot Password' }] as MenuItem[],
    },
  },
  {
    path: 'reset-password/:hash',
    title: 'mblty IQ - Reset Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Reset Password' }] as MenuItem[],
    },
  },
  {
    path: 'change-password',
    title: 'mblty IQ - Change Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Change Password' }] as MenuItem[],
    },
  },
  {
    path: 'set-password/:hash',
    title: 'mblty IQ - Set Password',
    component: ResetPasswordComponent,
    data: {
      breadcrumbs: [{ label: 'Set Password' }] as MenuItem[],
    },
  },
  {
    path: 'imprint',
    title: 'mblty IQ - Imprint',
    component: ImprintPageComponent,
    data: {
      breadcrumbs: [{ label: 'Imprint' }] as MenuItem[],
    },
  },
  {
    path: 'analysis',
    title: 'mblty IQ - Analysis',
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then(
        (c) => c.DashboardPageComponent,
      ),
    canActivate: [AuthGuard],
    data: {
      breadcrumbs: [{ label: 'Analysis' }] as MenuItem[],
    },
  },
  {
    path: 'location/:id/datasheet',
    title: 'mblty IQ - Location Datenblatt',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/location-datasheet-page/location-datasheet-page.component').then(
        (c) => c.LocationDatasheetPageComponent,
      ),
    data: {
      breadcrumbs: [
        { label: 'Locations', routerLink: '/locations/list' },
        { label: 'Datenblatt' },
      ] as MenuItem[],
    },
  },
  {
    path: 'location/:id/project',
    title: 'mblty IQ - Location Project',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/location-project-page/location-project-page.component').then(
        (c) => c.LocationProjectPageComponent,
      ),
    data: {
      breadcrumbs: [
        { label: 'Locations', routerLink: '/locations/list' },
        { label: 'Project' },
      ] as MenuItem[],
    },
  },
  {
    path: 'location/:id',
    title: 'mblty IQ - Location Dashboard',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/dashboard-page/dashboard-page.component').then(
        (c) => c.DashboardPageComponent,
      ),
    data: {
      breadcrumbs: [
        { label: 'Locations', routerLink: '/locations/list' },
        { label: 'Location Dashboard' /*, icon: 'fa-regular fa-chart-bar' */ },
      ] as MenuItem[],
    },
  },
  {
    path: 'locations',
    canActivate: [AuthGuard],
    children: [
      {
        path: 'list',
        title: 'mblty IQ - Locations',
        loadComponent: () =>
          import('./pages/location-list-page/location-list-page.component').then(
            (c) => c.LocationListPageComponent,
          ),
        data: {
          breadcrumbs: [{ label: 'Locations' }] as MenuItem[],
        },
      },
      {
        path: 'map',
        title: 'mblty IQ - Search Map',
        loadComponent: () =>
          import('./pages/location-map-page/location-map-page.component').then(
            (c) => c.LocationMapPageComponent,
          ),
        data: {
          breadcrumbs: [
            // { label: 'Locations', routerLink: ['..', 'list'] },
            { label: 'Search Map' },
          ] as MenuItem[],
        },
      },
    ],
  },
  {
    path: 'scoring-schema',
    title: 'mblty IQ - Scoring Schema',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/scoring-schema-page/scoring-schema-page.component').then(
        (c) => c.ScoringSchemaPageComponent,
      ),
    data: {
      breadcrumbs: [{ label: 'Scoring Schema' }] as MenuItem[],
    },
  },
  {
    path: 'users',
    title: 'mblty IQ - Users',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./pages/users-page/users-page.component').then(
        (c) => c.UsersPageComponent,
      ),
    data: {
      breadcrumbs: [{ label: 'Users' }] as MenuItem[],
    },
  },
  {
    path: '**',
    title: 'mblty IQ',
    redirectTo: 'login',
  },
];
